import { UPDATE_CART_LOAD, UPDATE_CART_LOAD_SUCCESS, UPDATE_CART_LOAD_FAIL } from './actions';

const initialState = {
  loaded: false,
  editing: {},
  saveError: {},
  data: [],
  extraData: {},
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case UPDATE_CART_LOAD:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_CART_LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: action.result,
        error: null,
        extraData: 'This is extra info..........',
      };
    case UPDATE_CART_LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: null,
        error: action.error,
      };
    default:
      return state;
  }
}
